export const colors = {
    primaryText: "#63605e",
    whiteShade: "#f8f1ee",
    orange: "#df6e34",
    lightGreyText: "#dfd5c9",
    portfolioBorder: "#d4c1a3",
    borderLineLighter: "#d79875",
    borderLineLight: "#cfc7be"
}
